export interface SingleResponse<T> {
	data: T
	message: string
}
